var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormInputRegular from '@marketing/components/funnel/FormFields/FormInputRegular';
import { CheckboxEmptyIcon, CheckboxIcon } from '@marketing/components/global/Icons';
import { clsx } from 'clsx';
import { useProfileContext } from '../ProfileContext';
import { isValidValue } from '@utils/form_validations';
import { formatPhone } from '@utils/formatting_utils';
var PhoneInput = function (_a) {
    var phone = _a.phone, setPhone = _a.setPhone, smsOptIn = _a.smsOptIn, setSmsOptIn = _a.setSmsOptIn, setIsValid = _a.setIsValid;
    var serverLoading = useProfileContext().serverLoading;
    var baseCheckboxSvgStyles = 'cursor-pointer size-5 peer-focus:ring-[3px] peer-focus:ring-offset-2 peer-focus:ring-shoe peer-focus:rounded-[2px]';
    var validatePhone = function (value) {
        var isValidPhone = isValidValue('phone', value);
        if (!isValidPhone) {
            setIsValid && setIsValid(isValidPhone);
            return {
                isValid: false,
                error: 'Please enter a valid phone number',
            };
        }
        setIsValid && setIsValid(true);
        return {
            isValid: true,
            error: '',
        };
    };
    return (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-8" }, { children: [_jsx(FormInputRegular, { autoComplete: "tel", id: "phone", label: "Phone Number", maxLength: 12, onInputChange: setPhone, pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}", type: "tel", value: formatPhone(phone), validate: validatePhone, disabled: serverLoading, debounceTimeout: 100 }), _jsxs("div", __assign({ className: "flex gap-3" }, { children: [_jsxs("label", __assign({ htmlFor: "sms-opt-in" }, { children: [_jsx("input", { className: "peer sr-only", autoComplete: "off", checked: smsOptIn === true, id: "sms-opt-in", name: "sms-opt-in", onChange: function () {
                                    setSmsOptIn(!smsOptIn);
                                }, type: "checkbox", value: smsOptIn ? 'true' : 'false', disabled: serverLoading }), smsOptIn ? (_jsx(CheckboxIcon, { className: clsx(baseCheckboxSvgStyles, 'text-shoe') })) : (_jsx(CheckboxEmptyIcon, { className: clsx(baseCheckboxSvgStyles) }))] })), _jsxs("span", { children: ["By checking this box you agree to receive updates about your order, delivery status, and exclusive offers and promotions from Nom Nom at the phone number provided. Consent is not a condition of purchase. Message & data rates may apply. Text STOP to cancel.", ' ', _jsx("a", __assign({ className: "font-bold underline", href: "/messaging-terms", target: "_blank" }, { children: "Terms" })), ' ', "and", ' ', _jsx("a", __assign({ className: "font-bold underline", href: "https://www.mars.com/privacy", target: "_blank", rel: "noreferrer" }, { children: "Privacy Policy" })), "."] })] }))] })));
};
export default PhoneInput;
